import React, { useContext } from "react";
import { useReducer  } from 'react';
import { Action, reducer, initialState } from '@/Action';
import styled from "styled-components";
import { ParticipantType } from "@/types";
import * as consts from "@/config/const";
import { useAuth } from "@/component/Auth";
import { Commond, RoleCode, UserInfo } from "@/types";
import { MeetingContext } from "@/pages/Meeting";
import { conference } from "@/api";
import { Avatar, Button, Dropdown, Menu } from "antd";
import prompt from "antd-prompt";
import { storage } from "@/util";
import * as meetingtool from "../mtools";
import { AudioIcon, HandIcon, VideoIcon, PinIcon } from "@/component/ToggleIcon";
import { MoreOutlined } from "@ant-design/icons";
import { useMqtt } from "@/hooks/use-mqtt";

interface ParticipantProp {
  participant: ParticipantType;
}

const Container = styled.div`
  padding: 10px 3px;
  border-bottom: 1px solid rgb(232, 232, 232);
  display: flex;
  align-items: center;
  &:hover {
    background: rgb(232, 232, 232);
  }
  .avatarFrm {
    width: 40px;
    height: 40px;
    .avatar {
      background: #1890ff;
    }
  }
  .names {
    margin-left: 5px;
    display: flex;
    flex-direction: column;
    font-size: 12px;
    .name {
      font-weight: bold;
    }
    .host {
      margin-top: 5px;
      padding: 2px 5px;
      border-radius: 2px;
      display: inline-block;
      background: rgb(143, 149, 158);
      color: #fff;
    }
  }
  .actions {
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: flex-end;

    .ant-btn:hover, .ant-btn:focus {
      color: rgba(0, 0, 0, 0.85);
      border-color: rgb(217, 217, 217);
    }
  }
`;

const Participant: React.FC<ParticipantProp> = ({ participant }) => {
  const { service } = useContext(MeetingContext);
  const auth = useAuth();
  const [state, dispatch] = useReducer(reducer, initialState);
  const loginfo: UserInfo = auth?.loginfo as UserInfo;
  const { userId } = loginfo;
  const { peerId, pinned } = participant;
  const { publish } = useMqtt()

  const { conference: conf, participants } = React.useContext(MeetingContext);

  const fromPeer = React.useMemo(() => {
    const rid = conf.roomId;
    return {
      peerid: `${rid}_${userId}`,
      deviceid: 8,
    };
  }, [conf.roomId, userId]);

  const toPeer = {
    peerid: participant.peerId,
  };

  const doAction = async (action: Commond, metadata?: string | number) => {
    conference.conferenceControl(
      {
        command: action,
        metadata: metadata,
        seq: "",
        room: conf.roomId,
        to: toPeer,
        from: fromPeer,
        // roleName: conf.roleName,
      },
      {
        "X-Conference-No": conf.conferenceNo,
        "X-Channel-Token": conf["X-Channel-Token"],
        "X-Conference-Token": conf["X-Conference-Token"],
      }
    );
  };

  const changeHame = async () => {
    try {
      const name = await prompt({
        title: "输入新名字",
        value: loginfo.realName,
        placeholder: "请输入新名字",
        rules: [
          {
            required: true,
            message: "请输入新名字",
          },
        ],
        modalProps: {
          width: "400px",
        },
      });
      doAction(Commond.changeNameByHost, name);
    } catch (e) {
      console.log("Please enter name");
    }
  };
  const setHost = () => doAction(Commond.grant, RoleCode.host);
  const setUniHost = () => doAction(Commond.grant, RoleCode.cohost);
  const removeUser = () => {
    // doAction(Commond.removeUser, "")
    publish({ command: Commond.removeUser, data: { peerId: participant.peerId }})
  };

  const broadcastUser = () => {
    publish({
      command: Commond.broadcastParticipant,
      data: {
        peerId: participant.peerId,
        operatorPeerId: `${conf.roomId}_${conf.userId}`,
      },
    });
  };

  const renameOk = React.useMemo(() => {
    return meetingtool.canRename(conf, participant, participants);
  }, [conf, participant, participants]);

  const hostOk = React.useMemo(() => {
    return meetingtool.canHost(conf, participant, participants);
  }, [conf, participant, participants]);

  const cohostOk = React.useMemo(() => {
    return meetingtool.canCohost(conf, participant, participants);
  }, [conf, participant, participants]);

  const isShowRemove = React.useMemo(() => {
    return meetingtool.showRemove(conf, participant, participants);
  }, [conf, participant, participants]);

  //// infos
  const isSelf = React.useMemo(() => {
    return meetingtool.isSelf(conf, participant);
  }, [conf, participant]);

  const isManage = meetingtool.selfIsManage(conf, participants);

  // 是不是 主持人，当前用户 2297170525
  const isHost = React.useMemo(() => {
    
    // console.log("isHost1:",participant);
    // console.log("isHost2:",conf);
    // console.log("isHost3:",participants);
    // console.log("isHost4 roleCode:",meetingtool.getPeer(conf, participant, participants).roleCode);
    dispatch({ type: 'SetCurrParticipant', payload: participant });
    if(participant && participant.roleCode === 20  ){
       console.log("isHost:"+ participant.peerName);
      
       return true
    }
    if(participants.length===1){
      return true;
    }
    // if(participant.peerId.includes(conf.userId)){
    //   alert("isHost:"+ participant.peerId+" ------"+conf.userId);
    //    return true;
    // }
    return false
    // storage.save(consts.CurrParticipant, participant);
    // return (
    //   meetingtool.getPeer(conf, participant, participants).roleCode ===
    //   RoleCode.host
    // );
  }, [conf, participant, participants]);

  const showMore = React.useMemo(() => {
    return renameOk || hostOk || cohostOk || isShowRemove;
  }, [cohostOk, hostOk, isShowRemove, renameOk]);

  const showHand = React.useMemo(() => {
    const isManage = meetingtool.selfIsManage(conf, participants);
    return !!(isSelf || (isManage && participant.raiseHandStatus));
  }, [conf, isSelf, participant, participants]);

  const muteAction = () => {
    // 是自己的话， 可以
    // 自己是管理对方不是，可以
    const isme = meetingtool.isSelf(conf, participant);
    const isManage = meetingtool.selfIsManage(conf, participants);
    const peer = meetingtool.getPeer(conf, participant, participants);
    // 自己的
    const meok =
      isme && (conf.allowSelfUnmute || (!conf.allowSelfUnmute && peer.audio));

    const otherok = !isme && isManage && peer.roleCode === RoleCode.guest;

    if (meok || otherok) {
      const action = peer.audio ? Commond.singleMute : Commond.singleUnMute;
      // doAction(action);
      publish({
        command: peer.audio ? Commond.singleMute : Commond.singleUnMute,
        data: {
          peerId: participant.peerId,
          operatorPeerId: `${conf.roomId}_${conf.userId}`,
        },
      })
    }
  };

  const videoAction = () => {
    // 是自己的话， 可以
    // 自己是管理对方不是，可以
    const isme = meetingtool.isSelf(conf, participant);
    const isManage = meetingtool.selfIsManage(conf, participants);
    const peer = meetingtool.getPeer(conf, participant, participants);
    if (isme || (isManage && peer.roleCode === RoleCode.guest)) {
      const action = peer.video ? Commond.shieldVideos : Commond.openVideos;
      // doAction(action);

      publish({
        command: peer.video ? Commond.shieldVideos : Commond.openVideos,
        data: {
          peerId: participant.peerId,
          operatorPeerId: `${conf.roomId}_${conf.userId}`,
        },
      })
    }
  };

  const handAction = () => {
    // 1，是自己 && 没有举手
    // 2, 不是自己并且guest， 自己是领导，并且已举手
    const isme = meetingtool.isSelf(conf, participant);
    const peer = meetingtool.getPeer(conf, participant, participants);
    const ismanage = meetingtool.selfIsManage(conf, participants);
    const selfCan = isme && !peer.raiseHandStatus;
    if (selfCan) doAction(Commond.raiseHand);

    const manageCan =
      !isme &&
      peer.roleCode === RoleCode.guest &&
      ismanage &&
      peer.raiseHandStatus;
    if (manageCan) doAction(Commond.singleHandsDown);
  };

  const togglePin = () => {
    service.pin(peerId, !pinned);
  };

  const menu = (
    <Menu>
      {renameOk && (
        <Menu.Item key="a1">
          <span onClick={changeHame}>改名</span>
        </Menu.Item>
      )}

      {hostOk ? (
        <Menu.Item key="a2">
          <span onClick={setHost}>设为主持人</span>
        </Menu.Item>
      ) : (
        <></>
      )}

      {cohostOk ? (
        <Menu.Item key="a3">
          <span onClick={setUniHost}>设为联席主持人</span>
        </Menu.Item>
      ) : (
        <></>
      )}

      {isManage && (
        <Menu.Item key="broadcast">
          <span onClick={broadcastUser}>广播该用户</span>
        </Menu.Item>
      )}

      {isManage && (
        <Menu.Item key="a4">
          <span onClick={removeUser}>移出会议</span>
        </Menu.Item>
      )}
    </Menu>
  );

  return (
    <Container>
      <div className="avatarFrm">
        <Avatar className="avatar" size="large">
          {participant.peerName && participant.peerName[0].toUpperCase()}
        </Avatar>
      </div>
      <div className="names">
        <div className="name">{`${participant.peerName}${
          isSelf ? "(我)" : ""
        }`}</div>
        {/* {isHost ? <div className="host">主持人!</div> : <></>} */}
      </div>
      <div className="actions">
        {/* {showHand && (
          <Button
            shape="circle"
            onClick={handAction}
            className="mr5"
            icon={<HandIcon active={participant.raiseHandStatus} />}
          />
        )} */}

      
        <Button
          shape="circle"
          onClick={togglePin}
          className="mr5"
          icon={<PinIcon active={participant.pinned} />}
        />
        


        {/* <Menu.Item icon={<PinIcon active={true} />} onClick={togglePin}>
        {pinned ? "取消固定" : "固定视频"}
      </Menu.Item> */}
        
       {/*{isHost && (
        <Button
        shape="circle"
        onClick={muteAction}
        className="mr5"
        icon={<AudioIcon active={participant.audio} />}
      />
      )}*/}
      {!isSelf && isManage && (
         <Button
         shape="circle"
         onClick={muteAction}
         className="mr5"
         icon={<AudioIcon active={participant.audio} />}
       />
      )}
        {/*{isHost &&
         <Button
         shape="circle"
         className="mr5"
         onClick={videoAction}
         icon={<VideoIcon active={participant.video} />}
       />
        }*/}
        {!isSelf && isManage && (
         <Button
         shape="circle"
         className="mr5"
         onClick={videoAction}
         icon={<VideoIcon active={participant.video} />}
       />
      )}
        {isHost && showMore && (
          <Dropdown overlay={menu}>
            <Button shape="circle" icon={<MoreOutlined rotate={90} />} />
          </Dropdown>
        )}
         {!isSelf && isManage && (
         <Dropdown overlay={menu}>
         <Button shape="circle" icon={<MoreOutlined rotate={90} />} />
       </Dropdown>
      )}
      </div>
    </Container>
  );
};

export default Participant;
